import { ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Navbar";

const APP_URL = "https://app.uzakyonetim.com.tr";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] pb-10 pt-20 text-[#FAFAFA]">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex flex-col justify-between gap-12 border-b border-white/10 pb-16 md:flex-row md:items-end">
          <div>
            <Logo dark size="lg" />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/50">
              Uzaktan Yönetim ve Destek Platformu. BT altyapınızı tek panelden
              izleyin, yönetin ve destekleyin.
            </p>
          </div>
          <a
            href={APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-login-button"
            className="group inline-flex items-center gap-2 text-sm font-semibold text-white/80 transition-colors duration-300 hover:text-white"
          >
            <span className="link-underline">Uygulamaya Giriş</span>
            <ArrowUpRight
              className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
              strokeWidth={1.5}
            />
          </a>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-6 text-xs text-white/40 md:flex-row md:items-center">
          <p>© 2026 UzakYönetim. Tüm hakları saklıdır.</p>
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2" aria-label="Yasal bağlantılar">
            <a href="/fiyatlar" data-testid="footer-link-fiyatlar" className="link-underline transition-colors duration-300 hover:text-white/80">
              Fiyatlar
            </a>
            <a href="/gizlilik" data-testid="footer-link-gizlilik" className="link-underline transition-colors duration-300 hover:text-white/80">
              Gizlilik Politikası
            </a>
            <a href="/kullanim-kosullari" data-testid="footer-link-kullanim" className="link-underline transition-colors duration-300 hover:text-white/80">
              Kullanım Koşulları
            </a>
            <a href="/kvkk" data-testid="footer-link-kvkk" className="link-underline transition-colors duration-300 hover:text-white/80">
              KVKK
            </a>
          </nav>
          <p>uzakyonetim.com.tr</p>
        </div>
      </div>
    </footer>
  );
}
